export default __webpack_public_path__ + "static/media/black-5.dbc2079d.png";